import { Link } from "react-router-dom";
import { course } from "@/src/lib/content";
import { BrandMark } from "@/src/components/BrandMark";

const external = [
  ["Iasa Global", "https://iasaglobal.org"],
  ["Project Atlas", "https://www.iasaglobal.org/university-programs-atlas/"],
  ["Metis", "https://metis.iasaglobal.org"],
  ["Sustainable Architectures", "https://sustainablearchitectures.org"],
  ["TU Dublin", "https://www.tudublin.ie"],
];

export function SiteHeader() {
  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="ecosystem-bar">
        <div className="shell ecosystem-inner" aria-label="Iasa education ecosystem">
          <span>Project Atlas education</span>
          <div className="ecosystem-links">
            {external.map(([label, href]) => <a key={label} href={href} target="_blank" rel="noopener">{label}</a>)}
          </div>
        </div>
      </div>
      <div className="shell nav-row">
        <Link className="brand" to="/">
          <BrandMark />
          <span><strong>Responsible Architectures</strong><small>Education for accountable systems</small></span>
        </Link>
        <nav aria-label="Primary navigation">
          <Link to="/programme">Programme</Link>
          <Link to="/about">How it is taught</Link>
          <Link to="/resources">Books &amp; resources</Link>
          <Link className="nav-student" to="/course">Enrolled students</Link>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div>
          <p className="footer-attribution"><a href="https://www.iasaglobal.org/university-programs-atlas/" target="_blank" rel="noopener">Brought to you by Project Atlas, the Iasa academic program</a></p>
          <p>{course.course_name} is developed by {course.developer} and offered first with {course.delivery_partner}.</p>
        </div>
        <div>
          <p><strong>{course.course_code}</strong><br />Release candidate · {course.regulatory_verified}</p>
          <p><Link to="/notice">Rights and attribution notice</Link><br />No open licence is implied.</p>
        </div>
      </div>
    </footer>
  );
}

export function Breadcrumbs({ items }: { items: Array<{ label: string; href?: string }> }) {
  return (
    <nav className="breadcrumbs shell" aria-label="Breadcrumb">
      <ol>
        <li><Link to="/">Home</Link></li>
        {items.map((item, index) => <li key={item.label} aria-current={index === items.length - 1 ? "page" : undefined}>{item.href ? <Link to={item.href}>{item.label}</Link> : item.label}</li>)}
      </ol>
    </nav>
  );
}

export function PageIntro({ eyebrow, title, lede }: { eyebrow: string; title: string; lede: string }) {
  return (
    <div className="page-intro shell">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p className="lede">{lede}</p>
    </div>
  );
}
